import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.css']
})
export class SuccessComponent implements OnInit {

  @Input() title: string;
  @Input() texts: string[];
  @Input() buttonText: string;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
  }


}
